import React, { PropTypes, useEffect } from "react";
import { Field } from "redux-form";
import { FormField } from "pickups-ui-library";
import { FormGroup, Button, Row, Col, Label, Alert } from "reactstrap";
import { withRouter } from "react-router";
import Autocomplete from "react-google-autocomplete";
import FormNavigation from "../navigation.component";

let NewLocationForm = (props) => {
  const {
    handleSubmit,
    submitting,
    error,
    isGatedCommunity,
    mapAddress,
    onClickAutoComplete,
    addressSelected,
    handleSelect,
    zipCode,
    existingLocation,
    previousStep,
    invalid,
    leaveInitialFlow,
    currentStep,
    setStep,
  } = props;

  const AddressFields = () => (
    <div>
      <Row>
        <Col sm={6} md={6}>
          <FormGroup>
            <Label>Street Address</Label>
            {addressSelected ? (
              <div
                className="form-control"
                onClick={() =>
                  !existingLocation && !addressSelected
                    ? onClickAutoComplete()
                    : null
                }
              >
                {addressSelected}
              </div>
            ) : (
              <Autocomplete
                apiKey={process.env.REACT_APP_GOOGLE_MAPS_API}
                // style={{width: '90%'}}
                className="form-control"
                onPlaceSelected={handleSelect}
                options={{
                  componentRestrictions: {
                    country: "US",
                  },
                  types: ["address"],
                }}
              />
            )}
          </FormGroup>
        </Col>
        <Col sm={6} md={6}>
          <Field
            name="unit"
            component={FormField}
            label="Unit"
            placeholder=""
            type="text"
          />
          <Field
            name="city"
            component={FormField}
            placeholder=""
            type={"hidden"}
          />
          <Field
            name="state"
            component={FormField}
            placeholder=""
            type={"hidden"}
            maxLength={2}
          />
          <Field
            type={"hidden"}
            heading={"Unit"}
            name={"zipCode"}
            component={FormField}
            required={true}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <form onSubmit={handleSubmit}>
      <div className={"box p-4"}>
        {mapAddress ? (
          <Row>
            <FormGroup>
              <Label>Pickup Address</Label>
              <div className={"form-control"}>{mapAddress}</div>
            </FormGroup>
          </Row>
        ) : (
          <AddressFields />
        )}
        {/*<Row>*/}
        {/*  <Col sm={6}>*/}
        {/*    <FormGroup>*/}
        {/*      <label htmlFor="gated">Gated Community</label>*/}
        {/*      <Field*/}
        {/*        name="gated"*/}
        {/*        component="input"*/}
        {/*        className="form-control"*/}
        {/*        type="checkbox"*/}
        {/*      />*/}
        {/*    </FormGroup>*/}
        {/*  </Col>*/}
        {/*  <Col sm={6}>*/}
        {/*    {isGatedCommunity ? (*/}
        {/*      <FormGroup>*/}
        {/*        <Field*/}
        {/*          name="gateCode"*/}
        {/*          component={FormField}*/}
        {/*          label="Gate Code*"*/}
        {/*          placeholder=""*/}
        {/*          type="text"*/}
        {/*        />*/}
        {/*      </FormGroup>*/}
        {/*    ) : null}*/}
        {/*  </Col>*/}
        {/*</Row>*/}
        {/*<Row>*/}
        {/*  <Col sm={12}>*/}
        {/*    <FormGroup>*/}
        {/*      <Field*/}
        {/*        name="development"*/}
        {/*        component={FormField}*/}
        {/*        label="Development"*/}
        {/*        placeholder=""*/}
        {/*        type="text"*/}
        {/*      />*/}
        {/*    </FormGroup>*/}
        {/*  </Col>*/}
        {/*  <Col sm={12}>*/}
        {/*    <FormGroup>*/}
        {/*      <Field*/}
        {/*        name="subdivision"*/}
        {/*        component={FormField}*/}
        {/*        label="Subdivision"*/}
        {/*        placeholder=""*/}
        {/*        type="text"*/}
        {/*      />*/}
        {/*    </FormGroup>*/}
        {/*  </Col>*/}
        {/*</Row>*/}
        <FormGroup>
          <Field
            name="notes"
            component={FormField}
            label="Additional instructions"
            placeholder=""
            type="text"
          />
        </FormGroup>
        <br />
        {error && <div className="error">{error}</div>}
      </div>
      <FormNavigation
        leaveInitialFlow={leaveInitialFlow}
        {...props}
        canSubmit={true}
      />
    </form>
  );
};

// NewLocationForm.propTypes = {
//     onSubmit : PropTypes.func.isRequired,
//     //onCancel : PropTypes.func.isRequired,
//     initialValues : PropTypes.object,
//     location : PropTypes.object,
//     //saveLocationAndCreatePickup : PropTypes.func.isRequired
// }

export default withRouter(NewLocationForm);
